export interface HoleLocationFields {
  pileNo: string | null
  gridLine: string | null
  location: string | null
}

export interface PreboreFields extends HoleLocationFields {
  preboreDepth: number | null
  preboreDrillSize: number | null
}

export function formatPreboreValue(value: number | null | undefined): string {
  return value != null ? String(value) : '-'
}

export function parseLocationPayload(
  pileNo: string | null | undefined,
  gridLine: string | null | undefined,
  location: string | null | undefined
): HoleLocationFields {
  return {
    pileNo: pileNo === '' || pileNo == null ? null : pileNo,
    gridLine: gridLine === '' || gridLine == null ? null : gridLine,
    location: location === '' || location == null ? null : location,
  }
}

export function parsePreborePayload(
  depth: string,
  drillSize: string,
  pileNo?: string | null,
  gridLine?: string | null,
  location?: string | null
): PreboreFields {
  return {
    preboreDepth: depth === '' ? null : Number(depth),
    preboreDrillSize: drillSize === '' ? null : Number(drillSize),
    ...parseLocationPayload(pileNo, gridLine, location),
  }
}

export function getLocationFromHole(hole: any): HoleLocationFields {
  return {
    pileNo: hole?.pileNo ?? null,
    gridLine: hole?.gridLine ?? null,
    location: hole?.location ?? null,
  }
}

export function getPreboreFromHole(hole: any): PreboreFields {
  return {
    preboreDepth: hole?.preboreDepth ?? null,
    preboreDrillSize: hole?.preboreDrillSize ?? null,
    ...getLocationFromHole(hole),
  }
}

export function formatPreboreCell(depth: number | null, drillSize: number | null): string {
  if (depth == null && drillSize == null) return '-'
  return `ความลึก: ${formatPreboreValue(depth)} / ขนาดสว่าน: ${formatPreboreValue(drillSize)}`
}
